// removed by extract-text-webpack-plugin
module.exports = {"contact-form-S":"contact-form-S","contact-form-group":"contact-form-group","form-control":"form-control","form-control-areal":"form-control-areal","form-control-icon":"form-control-icon","google-captcha":"google-captcha","contact-form-btn-wrap":"contact-form-btn-wrap","contact-form-btn":"contact-form-btn"};


//////////////////
// WEBPACK FOOTER
// ./components/contact/styleContact.scss
// module id = ./components/contact/styleContact.scss
// module chunks = 0